import { useMemo } from 'react';

import { useCurrentUserWorkflowTrackersContext } from '@/modules/workflowTrackers/contexts';
import { useOnWorkflowTrackerComplete } from '@/modules/workflowTrackers/hooks/useOnWorkflowTrackerComplete';
import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';

export function useHouseholdCopyTracker({
  onCompleted,
}: {
  onCompleted: () => void;
}) {
  const { trackers } = useCurrentUserWorkflowTrackersContext();
  const isCopying = useMemo(
    () =>
      trackers.some(
        (t) =>
          t.kind === WorkflowTrackerKind.HouseholdCopy &&
          t.status === WorkflowTrackerStatus.Started
      ),
    [trackers]
  );
  useOnWorkflowTrackerComplete({
    kind: WorkflowTrackerKind.HouseholdCopy,
    onCompleted,
  });
  return { isCopying };
}
